module.exports = __webpack_public_path__ + "static/media/icon-bell.abbfc6bd.svg";